import React, { useEffect, useState } from "react";
import { Col, Container, Row, Button, Toast } from "react-bootstrap";
import { Field, useFormikContext } from "formik";
import "./SelectButton";
import MaskedInput from "react-text-mask";
import "./Profile.css";
import "react-toastify/dist/ReactToastify.css";
import { FaTrashAlt} from "react-icons/fa";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCheck } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import Card from "react-bootstrap/Card";
import { formatDateToInputFormat } from "./util/helpers.js";

const EMPLOYEE_FIELDS = [
    "employer",
    "employerAddress",
    "employerSupervisor",
    "employerJobTitle",
    "employerDuties",
    "employerReason",
    "employerPhone",
    "employerStart",
    "employerEnd",
];

export const EmploymentHistory = () => {
    const {
        values: formikValues,
        setFieldValue,
        values,
        submitForm,
        errors,
    } = useFormikContext();
    const [employments, setEmployments] = useState([]);
    const [checkEmployment, setCheckEmployment] = useState(false)
    const [availableIds, setAvailableIds] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);

    const [employmentFieldsFilled, setEmploymentFieldsFilled] = useState(false);

    const addEmployment = () => {
        if (availableIds.length > 0) {
            const sortedAvailableIds = availableIds.slice().sort();

            let newId;

            for (let id of sortedAvailableIds) {
                const formikFields = EMPLOYEE_FIELDS.map(
                    (field) => field + (id + 1),
                );
                const doesEmploymentExist = formikFields.some(
                    (field) => formikValues[field],
                );

                if (!doesEmploymentExist) {
                    newId = id;
                    break;
                }
            }

            if (!newId && newId !== 0) {
                alert("Cannot add more than 10 employments");
                return;
            }

            setAvailableIds(availableIds.filter((id) => id !== newId));
            setEmployments([...employments, { id: newId }]);
        } else {
            alert("Cannot add more than 10 employments");
        }
    };
    const removeEmployment = (id) => {
        setEmployments((prevEmployments) =>
            prevEmployments.filter((emp) => emp.id !== id),
        );

        setAvailableIds([...availableIds, id]);
        EMPLOYEE_FIELDS.forEach((field) => {
            const fieldName = `${field}${id + 1}`;
            setFieldValue(fieldName, "");
        });
    };
    const createEmploymentsFromExistingValues = () => {
        let tempEmployments = [];
        for (let i = 1; i <= 10; i++) {
            let hasFieldsForThisEmployment = EMPLOYEE_FIELDS.some(
                (field) => formikValues[`${field}${i}`],
            );
            if (hasFieldsForThisEmployment) {
                tempEmployments.push({ id: i - 1 });
            }
        }
        setEmployments(tempEmployments);
    };


    const fieldMaxLengths = {
        employerAddress1: 200,
        employerReason1: 200,
        employerDuties1: 2000,
        employerAddress2: 200,
        employerReason2: 200,
        employerDuties2: 2000,
        employerAddress3: 200,
        employerReason3: 200,
        employerDuties3: 2000,
        employerAddress4: 200,
        employerReason4: 200,
        employerDuties4: 2000,
        employerAddress5: 200,
        employerReason5: 200,
        employerDuties5: 2000,
        employerAddress6: 200,
        employerReason6: 200,
        employerDuties6: 2000,
        employerAddress7: 200,
        employerReason7: 200,
        employerDuties7: 2000,
        employerAddress8: 200,
        employerReason8: 200,
        employerDuties8: 2000,
        employerAddress9: 200,
        employerReason9: 200,
        employerDuties9: 2000,
        employerAddress10: 200,
        employerReason10: 200,
        employerDuties10: 2000,
    };

    const allFieldsFilledForEmployment = (emplNumber) =>
        values[`employer${emplNumber}`] &&
        values[`employerAddress${emplNumber}`] &&
        values[`employerDuties${emplNumber}`] &&
        values[`employerJobTitle${emplNumber}`] &&
        values[`employerPhone${emplNumber}`] &&
        values[`employerReason${emplNumber}`] &&
        values[`employerSupervisor${emplNumber}`] &&
        values[`employerEnd${emplNumber}`] &&
        values[`employerStart${emplNumber}`];

    useEffect(() => {
        setEmploymentFieldsFilled(
            allFieldsFilledForEmployment(employments.length),
        );
    }, [employments, values]);

    useEffect(() => {
        createEmploymentsFromExistingValues();
    }, []);

    useEffect(() => {  
        if(employments.length === 0){
            setCheckEmployment(false)
        } else {
            setCheckEmployment(true)
        }
    }, [employments])

    return (
        <>
            <Container className="container2 px-3">
                {employmentFieldsFilled && (
                    <div
                        className="alert alert-success text-center success-msg animate__animated animate__fadeInUp mt-2 mb-0"
                        role="alert"
                    >
                        <h4 className="alert-heading fw-bold fs-5 fs-md-4">
                            <FontAwesomeIcon
                                icon={faCheck}
                                style={{
                                    color: "cornflowerblue",
                                    fontSize: "1.5em",
                                }}
                                className="fa-fw fa-xs d-md-inline-block me-md-2 pt-1"
                            />
                        </h4>
                        Great! You can proceed to the next step.
                    </div>
                )}

                <Row className="d-flex justify-content-center">

                        <h3 className="header-font"><span>Employment History</span></h3>

                        <Row className="d-flex justify-content-center mt-1 ">
                            <Col xs={"auto"} className="mx-0">
                                <label className="info-label text-center px-0 mx-0 pt-1 w-auto">
                                    A maximum of six employments can be added for any given user.
                                </label>
                            </Col>
                        </Row>
                        <Row className="d-flex justify-content-center ">
                            <p className="select-text w-auto fst-italic fw-bold text-center success-msg">
                                * Recent Employment First.
                            </p>
                        </Row>

                </Row>
                <Row className="rounded-3 mx-auto d-flex justify-content-center">
                    {employments.map((emp) => (
                        <Card
                            key={emp.id}
                            className="mb-4 no-padding py-0 full-width-card "
                        >
                            <Card.Header className="d-flex flex-column flex-md-row justify-content-md-between align-items-center bottom-border w-100 mx-auto">
                                <Label
                                    className=" pt-1 me-2"
                                    keyValue={`headerLabel-${emp.id}`}
                                >
                                    <span> Employment History: </span>
                                    <p className=" large-text  ">
                                        {emp.id + 1}
                                    </p>
                                </Label>
                                <div className="mt-2 mt-md-0 ml-md-5 d-flex justify-content-around justify-content-md-end w-100">


                                            <Button
                                                className="transparent-btn me-2"
                                                onClick={async () => {
                                                    let result =
                                                        await Swal.fire({
                                                            title: "Are you sure?",
                                                            text: "You won't be able to revert this!",
                                                            icon: "warning",
                                                            showCancelButton: true,
                                                            confirmButtonColor:
                                                                "#3085d6",
                                                            cancelButtonColor:
                                                                "#d33",
                                                            confirmButtonText:
                                                                "Yes, delete it!",
                                                        });

                                                    if (result.isConfirmed) {

                                                        removeEmployment(
                                                            emp.id,
                                                        );
                                                        await submitForm();
                                                    }
                                                }}
                                            >
                                                <FaTrashAlt
                                                    className="icon trash-icon"
                                                    style={{ fontSize: "20px" }}
                                                />
                                            </Button>


                                </div>
                            </Card.Header>
                            <Card.Body>

                                    <>
                                        {EMPLOYEE_FIELDS.map((field, idx) => (
                                            <React.Fragment key={idx}>
                                                <Row
                                                    key={idx}
                                                    className="d-flex justify-content-center my-4 w-100 mx-auto"
                                                >
                                                    {extractLabelAndField(
                                                        `${field}${emp.id + 1}`,
                                                        "",
                                                        field,
                                                        `${field}-${emp.id}-${idx}`,
                                                    )}
                                                </Row>
                                            </React.Fragment>
                                        ))}

                                    </>

                            </Card.Body>
                        </Card>
                    ))}

                </Row>
                {(employments.length < 10) || employments.length === 0 ? (
                    <Row className="d-flex justify-content-center">
                        <Col xs="auto">
                            <button
                                type="button"
                                className="add-employment-button animate__animated animate__fadeIn"
                                onClick={addEmployment}
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </Col>
                    </Row>
                ) : employments.length === 10 ? (
                    <Row className="d-flex justify-content-center ">
                        <p className="select-text w-auto fst-italic fw-bold text-center success-msg">
                            * You have reached the maximum number of employments that can be added.
                        </p>
                    </Row>
                ) : (<>
                    <Row className="d-flex justify-content-center ">
                        <p className="select-text w-auto fst-italic fw-bold success-msg">
                            * Please complete your current employment history before adding more.
                        </p>
                    </Row>
                </>)}

                {checkEmployment === false && (
                    <>
                        <Row className="d-flex justify-content-center ">
                            <p className="text-danger w-auto fst-italic fw-bold text-center success-msg">
                                * Some positions within the Navajo Nation might
                                necessitate work experience to qualify for these positions.
                                <br /> Please carefully read the job description
                                for the role you&apos;re interested in and enter your employment history to qualify.
                            </p>
                        </Row>
                    </>
                )}
            </Container>
        </>
    );
    function Label({ className, children, key, style }) {
        const fieldLabels = {
            employer1: "Employer Name",
            employerAddress1: "Employer Address",
            employerSupervisor1: "Supervisor Name",
            employerJobTitle1: "Job Title",
            employerDuties1: "Job Description",
            employerReason1: "Reason for Leaving",
            employerPhone1: "Employer Phone",
            employerStart1: "Start Date",
            employerEnd1: "End Date",
            employer2: "Employer Name",
            employerAddress2: "Employer Address",
            employerSupervisor2: "Supervisor Name",
            employerJobTitle2: "Job Title",
            employerDuties2: "Job Description",
            employerReason2: "Reason for Leaving",
            employerPhone2: "Employer Phone",
            employerStart2: "Start Date",
            employerEnd2: "End Date",
            employer3: "Employer Name",
            employerAddress3: "Employer Address",
            employerSupervisor3: "Supervisor Name",
            employerJobTitle3: "Job Title",
            employerDuties3: "Job Description",
            employerReason3: "Reason for Leaving",
            employerPhone3: "Employer Phone",
            employerStart3: "Start Date",
            employerEnd3: "End Date",
            employer4: "Employer Name",
            employerAddress4: "Employer Address",
            employerSupervisor4: "Supervisor Name",
            employerJobTitle4: "Job Title",
            employerDuties4: "Job Description",
            employerReason4: "Reason for Leaving",
            employerPhone4: "Employer Phone",
            employerStart4: "Start Date",
            employerEnd4: "End Date",
            employer5: "Employer Name",
            employerAddress5: "Employer Address",
            employerSupervisor5: "Supervisor Name",
            employerJobTitle5: "Job Title",
            employerDuties5: "Job Description",
            employerReason5: "Reason for Leaving",
            employerPhone5: "Employer Phone",
            employerStart5: "Start Date",
            employerEnd5: "End Date",
            employer6: "Employer Name",
            employerAddress6: "Employer Address",
            employerSupervisor6: "Supervisor Name",
            employerJobTitle6: "Job Title",
            employerDuties6: "Job Description",
            employerReason6: "Reason for Leaving",
            employerPhone6: "Employer Phone",
            employerStart6: "Start Date",
            employerEnd6: "End Date",
            employer7: "Employer Name",
            employerAddress7: "Employer Address",
            employerSupervisor7: "Supervisor Name",
            employerJobTitle7: "Job Title",
            employerDuties7: "Job Description",
            employerReason7: "Reason for Leaving",
            employerPhone7: "Employer Phone",
            employerStart7: "Start Date",
            employerEnd7: "End Date",
            employer8: "Employer Name",
            employerAddress8: "Employer Address",
            employerSupervisor8: "Supervisor Name",
            employerJobTitle8: "Job Title",
            employerDuties8: "Job Description",
            employerReason8: "Reason for Leaving",
            employerPhone8: "Employer Phone",
            employerStart8: "Start Date",
            employerEnd8: "End Date",
            employer9: "Employer Name",
            employerAddress9: "Employer Address",
            employerSupervisor9: "Supervisor Name",
            employerJobTitle9: "Job Title",
            employerDuties9: "Job Description",
            employerReason9: "Reason for Leaving",
            employerPhone9: "Employer Phone",
            employerStart9: "Start Date",
            employerEnd9: "End Date",
            employer10: "Employer Name",
            employerAddress10: "Employer Address",
            employerSupervisor10: "Supervisor Name",
            employerJobTitle10: "Job Title",
            employerDuties10: "Job Description",
            employerReason10: "Reason for Leaving",
            employerPhone10: "Employer Phone",
            employerStart10: "Start Date",
            employerEnd10: "End Date",
        };

        const getLabel = (fieldName) => {
            return fieldLabels[fieldName] || fieldName;
        };

        const label = getLabel(children);

        return (
            <Col xs={"auto"} key={key} className={className} style={style}>
                <label
                    className="info-label text-center pt-1 pb-0 mb-0"
                    style={{ whiteSpace: "nowrap" }}
                >
                    {label}
                </label>
            </Col>
        );
    }

    function extractLabelAndField(name, className, label, key, disabled) {
        const inputStyles = {
            backgroundColor: disabled ? "#EEE" : "white",
        };

        const isDateField = name.includes("Start") || name.includes("End");

        const isPhoneField = name.includes("Phone");

        return (
            <>
                <React.Fragment key={key}>
                    <Row className=" w-100 d-flex justify-content-center">
                        <Col xs={12} lg={6}>
                            <Label>{name}</Label>
                            {name.includes("End1") && (
                                <Row className="d-flex justify-content-center">
                                    <p className="select-text w-auto fst-italic fw-bold w-100 current-emp-msg py-0 my-0 ">
                                        <span>
                                            * Enter current date if currently
                                            employed
                                        </span>
                                    </p>
                                </Row>
                            )}
                            {isDateField ? (
                                <div
                                    style={{ width: "229px" }}
                                    className="mb-0 pb-0"
                                >
                                    <GeneralTextAreaField
                                        className="form-control"
                                        type="date"
                                        name={name}
                                        disabled={disabled}
                                        value={formatDateToInputFormat(
                                            values[name],
                                        )}
                                        placeholder="MM/DD/YYYY"
                                    />
                                </div>
                            ) : isPhoneField ? (
                                <div
                                    style={{
                                        width: "250px",
                                        marginLeft: "-10px",
                                    }}
                                >
                                    <Field name={name}>
                                        {({ field, meta }) => {
                                            let validationCheck;

                                            if (meta.touched && meta.error) {
                                                validationCheck = "is-invalid";
                                            } else if (
                                                meta.touched &&
                                                !meta.error
                                            ) {
                                                validationCheck = "is-valid";
                                            }

                                            return (
                                                <>
                                                    <MaskedInput
                                                        disabled={disabled}
                                                        mask={[
                                                            "(",
                                                            /[1-9]/,
                                                            /\d/,
                                                            /\d/,
                                                            ")",
                                                            " ",
                                                            /\d/,
                                                            /\d/,
                                                            /\d/,
                                                            "-",
                                                            /\d/,
                                                            /\d/,
                                                            /\d/,
                                                            /\d/,
                                                        ]}
                                                        className={
                                                            "form-control " +
                                                            validationCheck
                                                        }
                                                        {...field}
                                                    />
                                                    {!meta.touched &&
                                                        meta.error ? (
                                                        <p className="text-danger py-0 my-0 ">
                                                            {meta.error}
                                                        </p>
                                                    ) : null}
                                                    {meta.touched &&
                                                        meta.error ? (
                                                        <p className="text-danger py-0 my-0">
                                                            {meta.error}
                                                        </p>
                                                    ) : null}
                                                </>
                                            );
                                        }}
                                    </Field>
                                </div>
                            ) : (
                                <GeneralTextAreaField
                                    className="form-control"
                                    component="textarea"
                                    rows="2"
                                    name={name}
                                    disabled={disabled}
                                    style={inputStyles}
                                    maxLength={fieldMaxLengths[name]}
                                />
                            )}
                        </Col>
                    </Row>
                </React.Fragment>
            </>
        );
    }
};
